import Image from 'next/image'
import Link from 'next/link'

import classes from './ProductFiftyFifty.module.scss'

const HeaderSize = {
  LARGE: 'large-header',
  SMALL: 'small-header',
};

const SubheaderSize = {
  LARGE: 'large-subheader',
  SMALL: 'small-subheader',
};

const ProductFiftyFifty = ({ fields }) => {
  const {
    title,
    alt,
    headerSize,
    subheaderSize,
    topPadding,
    bottomPadding,
    image,
  } = fields

  let className = `${classes['fifty-fifty__row']} ${classes[fields.imageAlign]} ${classes['container']} flex--justify-between`

  if (topPadding) {
    className += ` ${classes['top-padding']}`;
  }

  if (bottomPadding) {
    className += ` ${classes['bottom-padding']}`;
  }

  return (
    <div className={classes['fifty-fifty']}>
      <div className={className}>
        {image && (
          <div className={classes['fifty-fifty__image']}>
            <Image
              className={classes.mbl__img}
              src={image?.asset?.url}
              layout="fill"
              alt={alt || title}
            />
          </div>
        )}
        <div className={classes['fifty-fifty__text']}>
          {fields.header && headerSize === HeaderSize.LARGE && (
            <h2>{fields.header}</h2>
          )}

          {fields.header && headerSize === HeaderSize.SMALL && (
            <h2>{fields.header}</h2>
          )}

          {fields.subheader && subheaderSize === SubheaderSize.LARGE && (
            <p>{fields.subheader}</p>
          )}
          {fields.subheader && subheaderSize === SubheaderSize.SMALL && (
            <p>{fields.subheader}</p>
          )}

          <div className={classes['links']}>
            {fields.ctaUrl && (
              <Link href={`${fields.ctaUrl}`} legacyBehavior>
                <a
                  className={`${classes['btn']} btn salmon no-underline text-align--center`}
                >
                  {fields.ctaText}
                </a>
              </Link>
            )}

            {fields.ctaUrl2 && (
              <Link href={`${fields.ctaUrl2}`} legacyBehavior>
                <a
                  className={`${classes['btn']} btn salmon no-underline text-align--center`}
                >
                  {fields.ctaText2}
                </a>
              </Link>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}

export default ProductFiftyFifty
